import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";
import { Box, useMediaQuery } from "@mui/material";
import CustomTypography from "../Typography";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Virtual } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/virtual";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const CustomTooltip = ({
  title,
  children,
  placement = "top",
  moreInfo,
  tooltipSxStyles,
  tooltipTitleSxStyles,
}) => {
  const { t } = useTranslation(["sku-more-info-text"]);

  const isMobile = useMediaQuery("(max-width:768px)");
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (!isMobile) return;

    const handleClose = () => setOpen(false);

    if (isOpen) {
      document.addEventListener("touchstart", handleClose, { passive: true });
      document.addEventListener("scroll", handleClose, { passive: true });
    }

    return () => {
      document.removeEventListener("touchstart", handleClose);
      document.removeEventListener("scroll", handleClose);
    };
  }, [isOpen, isMobile]);

  const renderTooltipContent = () => {
    return (
      <Box
        sx={{
          maxWidth: 300,
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {moreInfo?.images && moreInfo.images.length > 0 && (
          <Box sx={{ width: "100%", position: "relative" }}>
            <Swiper
              modules={[Navigation, Virtual]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              virtual
              preloadImages={false}
              style={{
                "--swiper-navigation-size": "16px",
                "--swiper-navigation-color": "#ffffff",
              }}
            >
              {moreInfo.images.map((image, index) => (
                <SwiperSlide key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "113px",
                    }}
                  >
                    <img
                      src={image}
                      alt={`Variant ${index + 1}`}
                      loading="lazy"
                      style={{
                        width: "134px",
                        height: "113px",
                        objectFit: "cover",
                        borderRadius: 4,
                      }}
                      className="swiper-slide"
                    />
                  </Box>
                </SwiperSlide>
              ))}
              {moreInfo.images.length > 1 && (
                <>
                  <div className="swiper-button-prev" />
                  <div className="swiper-button-next" />
                </>
              )}
            </Swiper>
          </Box>
        )}

        <CustomTypography
          props={{
            color: "#FFFFFF",
            fontSize: "15px",
            fontWeight: "400",
            ...tooltipTitleSxStyles,
          }}
        >
          {t(moreInfo?.text) || t(title)}
        </CustomTypography>
      </Box>
    );
  };

  return (
    <Tooltip
      title={renderTooltipContent()}
      arrow
      placement={placement}
      onClick={() => (isMobile ? setOpen(true) : null)}
      open={isOpen}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      enterTouchDelay={0}
      leaveTouchDelay={999999}
      disableFocusListener
      disableTouchListener
      slots={{
        transition: Fade,
      }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -8],
              },
            },
          ],
        },
        tooltip: {
          sx: {
            backgroundColor: "#2F2B3D",
            padding: "12px",
            borderRadius: "8px",
            maxWidth: "none",
            ...tooltipSxStyles,
          },
        },
        arrow: {
          sx: {
            color: "#2F2B3D",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
